export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="30" viewBox="0 0 34 30" fill="none">
            <path d="M6.0625 7.70831H17" stroke="black" strokeWidth="2.73438" />
            <path d="M6.0625 15H15.1771" stroke="black" strokeWidth="2.73438" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.32812 26.849V3.15106H25.2031V7.70833H27.9375V2.2396C27.9375 1.23283 27.1214 0.416687 26.1146 0.416687H2.41667C1.4099 0.416687 0.59375 1.23283 0.59375 2.2396V27.7604C0.59375 28.7672 1.4099 29.5834 2.41667 29.5834H11.5312V26.849H3.32812Z"
                fill="black"
            />
            <circle cx="24.6969" cy="14.7164" r="3.81801" stroke="black" strokeWidth="2.73438" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30.4078 29.5833C30.5797 29.0057 30.672 28.3938 30.672 27.7604C30.672 24.2367 27.8155 21.3802 24.2918 21.3802C20.7681 21.3802 17.9116 24.2367 17.9116 27.7604C17.9116 28.3938 18.0039 29.0057 18.1758 29.5833H15.3596C15.24 28.9943 15.1772 28.3847 15.1772 27.7604C15.1772 22.7266 19.258 18.6458 24.2918 18.6458C29.3257 18.6458 33.4064 22.7266 33.4064 27.7604C33.4064 28.3847 33.3436 28.9943 33.2241 29.5833H30.4078Z"
                fill="black"
            />
        </svg>
    );
}
